import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { FileDown } from 'lucide-react';

import { Button } from '../../components/ui/button';
import { SectionTabs } from '../../shared/ui/SectionTabs';
import { TopbarActions } from '../../shared/ui/TopbarSlot';
import { ROUTES } from '../../shared/config/routes';
import { PERIOD_PARAM_KEYS } from '../../features/statistics/hooks/useDateRangeParams';
import { withKeptParams } from '../../shared/ui/SectionTabs';

/**
 * Раздел «Статистика». Свёл в себя прежние «Dashboard», «Статистика»,
 * «Аналитика» (5 вкладок) и «Авто-отчёты» — они были четырьмя пунктами меню,
 * хотя отвечали на один вопрос «как идут дела».
 *
 * Имя раздела и выгрузка стоят в топбаре, поэтому страница начинается сразу
 * с вкладок: подпись под заголовком пересказывала то, что и так написано на
 * вкладке, и съедала строку на телефоне.
 */
export function StatsLayout(): JSX.Element {
  const navigate = useNavigate();
  const { search } = useLocation();

  return (
    <div className="flex flex-col gap-4">
      <TopbarActions>
        <Button variant="outline" onClick={() => navigate(withKeptParams(ROUTES.STATS_REPORT, search, PERIOD_PARAM_KEYS))}>
          <FileDown className="h-4 w-4" />
          Выгрузить отчёт
        </Button>
      </TopbarActions>

      {/* Период один на весь раздел: вкладки несут его в адресе. */}
      <SectionTabs
        keepParams={PERIOD_PARAM_KEYS}
        tabs={[
          { to: ROUTES.STATS, label: 'Сводка', end: true },
          { to: ROUTES.STATS_ACCOUNTS, label: 'По аккаунтам' },
          { to: ROUTES.STATS_LINKS, label: 'По ссылкам' },
          { to: ROUTES.STATS_AVERAGES, label: 'Средние просмотры' },
          { to: ROUTES.STATS_TIMELINE, label: 'Хронология' },
          { to: ROUTES.STATS_PARTNERS, label: 'Партнёры' },
        ]}
      />

      <Outlet />
    </div>
  );
}
